window.Config = {
    title: 'Time Stables',
    api: {
        // url: 'http://localhost:8000/api'
        url: 'https://api.timestables.nl/api'
    },
    enabledLanguageCodes: ['nl', 'en']
};

export { }